"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_link_1 = require("apollo-link");
var wsNormalizationLink = new apollo_link_1.ApolloLink(function (operation, forward) {
    var result = forward(operation);
    // detect WebSocketLink ugly observable, convert to zen
    return typeof result.map !== 'function' ? apollo_link_1.Observable.from(result) : result;
});
exports.default = wsNormalizationLink;
//# sourceMappingURL=ws-normalization-link.js.map